const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const pesoPalotIdsByPeso = {
  183: 1,
  194: 2,
};

const pesoCajaIdsByPeso = {
  18: 1,
  19: 2,
  20: 3,
};

const buildClassificationWithPalots = (entrada, kilosField, palotsField) => ({
  kilos: toNumber(entrada[kilosField]),
  palots: toNumber(entrada[palotsField]),
});

export const buildEntradaPayload = (entrada) => {
  const kilosPalot = toNumber(entrada.kilosPalot);
  const pesoCaja = toNumber(entrada.pesoCaja);

  return {
    fecha: entrada.fecha || null,
    id_almacen: toNumber(entrada.idAlmacen),
    codigo_variedad: String(entrada.idVariedad || ''),
    kilos: toNumber(entrada.kilos),
    grupos_4_palots: toNumber(entrada.crucesPalots),
    id_peso_palot: toNumber(entrada.idPesoPalot) || pesoPalotIdsByPeso[kilosPalot] || kilosPalot,
    id_peso_caja: toNumber(entrada.idPesoCaja) || pesoCajaIdsByPeso[pesoCaja] || pesoCaja,
    observaciones: entrada.observaciones ?? '',
    palets_entrada: Object.entries(entrada.paletsEntrada || {}).map(([idCajaPalet, cantidad]) => ({
      id_caja_palet: toNumber(idCajaPalet),
      cantidad: toNumber(cantidad),
    })),
    clasificacion: {
      precalibrado: buildClassificationWithPalots(entrada, 'otrosCalibres', 'pOtrosCalibres'),
      retorno: buildClassificationWithPalots(entrada, 'retorno', 'pRetorno'),
      verde: buildClassificationWithPalots(entrada, 'verde', 'pVerde'),
      segunda: buildClassificationWithPalots(entrada, 'segunda', 'pSegunda'),
      bajo_calibre: buildClassificationWithPalots(entrada, 'bajoCalibre', 'pBajoCalibre'),
      industria: buildClassificationWithPalots(entrada, 'industria', 'pIndustria'),
      podrido: {
        kilos: toNumber(entrada.podrido),
      },
    },
  };
};
